import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-incoming-call-icon',
  templateUrl: './communication-incoming-call.component.html'
})
export class CommunicationIncomingCallComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
